// sway

export const BASELINES_CRUD = (tenant: string) => `/api/sway/tenant/${tenant}/baseline`;
